"use client";
import { j as t } from "./jsx-runtime-CJ-St4mQ.mjs";
import { useMemo as I } from "react";
import { s as R } from "./ChevronRightIcon-iheg0enf.mjs";
import j from "./IconButton.js";
const k = ({
  title: n,
  titleId: r,
  desc: s,
  descId: e,
  ...o
}) => /* @__PURE__ */ t.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": r,
    "aria-describedby": e,
    ...o,
    children: [
      s ? /* @__PURE__ */ t.jsx("desc", { id: e, children: s }) : null,
      n ? /* @__PURE__ */ t.jsx("title", { id: r, children: n }) : null,
      /* @__PURE__ */ t.jsx(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.5,
          d: "m14 17-5-5 5-5"
        }
      )
    ]
  }
), v = ({
  count: n,
  itemsPerPage: r,
  siblingCount: s = 1,
  page: e
}) => {
  const o = I(() => {
    const i = Math.ceil(n / r);
    if (s + 5 >= i)
      return Array.from({ length: i }, (c, x) => x + 1);
    const a = Math.max(e - s, 1), m = Math.min(e + s, i), g = a > 2, u = m < i - 2, y = 1, w = i;
    if (!g && u)
      return [...Array.from(
        { length: 3 + 2 * s },
        (x, d) => d + 1
      ), "...", w];
    if (g && !u) {
      const c = Array.from(
        { length: 3 + 2 * s },
        (x, d) => i - (3 + 2 * s) + d + 1
      );
      return [y, "...", ...c];
    } else if (g && u) {
      const c = Array.from(
        { length: 2 * s + 1 },
        (x, d) => a + d
      );
      return [y, "...", ...c, "...", w];
    } else
      return [];
  }, [n, r, s, e]), h = Math.min((e - 1) * r + 1, n), l = Math.min(e * r, n), f = `Showing ${h} to ${l} of ${n} results`;
  return {
    paginationRange: o,
    displayText: f,
    startItem: h,
    endItem: l
  };
}, A = (n) => {
  const { count: r, itemsPerPage: s, page: e, onPageChange: o, siblingCount: h = 1 } = n, { paginationRange: l, displayText: f } = v({
    count: r,
    itemsPerPage: s,
    siblingCount: h,
    page: e
  });
  if (e === 0 || l.length < 2)
    return null;
  const i = () => {
    o(e + 1);
  }, p = () => {
    o(e - 1);
  };
  return /* @__PURE__ */ t.jsxs("div", { className: "flex justify-between items-center py-4", children: [
    /* @__PURE__ */ t.jsx("div", { children: /* @__PURE__ */ t.jsx("p", { children: f }) }),
    /* @__PURE__ */ t.jsxs("nav", { className: "inline-flex items-center gap-x-1", children: [
      /* @__PURE__ */ t.jsx(
        j,
        {
          onClick: p,
          disabled: e === 1,
          color: "primary",
          className: "size-8 grid place-items-center",
          children: /* @__PURE__ */ t.jsx(k, {})
        }
      ),
      l.map((a, m) => a === "..." ? /* @__PURE__ */ t.jsx("span", { className: "mx-2 ", children: "..." }, m) : /* @__PURE__ */ t.jsx(
        j,
        {
          color: a === e ? "primary" : "default",
          className: "flex-grow-0  size-8 grid place-items-center ",
          onClick: () => o(Number(a)),
          children: a
        },
        m
      )),
      /* @__PURE__ */ t.jsx(
        j,
        {
          color: "primary",
          className: "size-8 grid place-items-center",
          onClick: i,
          disabled: e === l[l.length - 1],
          children: /* @__PURE__ */ t.jsx(R, {})
        }
      )
    ] })
  ] });
};
export {
  A as default
};
